import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Outlet } from 'react-router-dom';

import { Footer } from '@/components/Footer';
import { PublicTopNavBar } from '@/components/PublicTopNavBar';
import { ScrollToPagePosition } from '@/components/ScrollToPagePosition';

export const PublicMainLayout = () => {
    return (
        <>
            <ScrollToPagePosition />
            <Stack
                sx={{
                    backgroundColor: '#d0d5dd10',
                    minHeight: '100vh',
                }}
            >
                <PublicTopNavBar />
                <Box flexGrow={1}>
                    <Outlet />
                </Box>
                <Footer />
            </Stack>
        </>
    );
};
